module.exports = __webpack_public_path__ + "img/s9-2.a4b82960.jpg";